import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';

export const issueSecurityLevelProjectLimitMetricDetailEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-issue-security-level-project-limit" */ '@jira/spa-apps__admin-pages-performance-metric-detail-issue-security-level-project-limit/src/IssueSecurityLevelProjectLimitDetail.tsx'
				),
		),
		getPreloadProps: () => ({}),
	},
});
